import React from "react";
import { BrowserRouter, Switch } from "react-router-dom";
import {
	AnonymousRoute,
	Notification,
	SpinnerOverlay,
	ModalManager,
	PageNotFound,
} from "components";
import { Stepper } from "../stepper";

export const App = () => {
	return (
		<>
			<Notification />
			<SpinnerOverlay />
			<ModalManager />
			<BrowserRouter>
				<Switch>
					<AnonymousRoute
						path="/error"
						component={PageNotFound}
						pageName="Pre Application"
					/>
					<AnonymousRoute
						path="/:alias?"
						component={Stepper}
						pageName="Pre Application"
					/>
					{/*
						ATTENTION!!! This route have to be the last one always.
						The route must be rendered only if path does not match any previous routes
					*/}
					{/* <AnonymousRoute
						component={PageNotFound}
						pageName="Not found"
					/> */}
				</Switch>
			</BrowserRouter>
		</>
	);
};
